import request from '@/utils/request'

// 近期活动分页
export function getActivity(data) {
	return request({
		url:'/app-api/biz/home/get-activity-page',
		method: 'get',
		params: data
	})
}

// 近期活动详情
export function getActivityDetail(data) {
	return request({
		url:'/app-api/biz/home/get-activity',
		method: 'get',
		params: data
	})
}
// 活动报名信息
export function getRegistration(data) {
	return request({
		url:'/app-api/biz/my/get-event-registration',
		method: 'get',
		params: data
	})
}
// 创建活动报名
export function getCreate(data) {
	return request({
		url:'/app-api/biz/home/create-event-registration',
		method: 'post',
		data
	})
}
// 提交支付订单
export function orderSubmit(data) {
	return request({
		url:'/app-api/pay/order/submit',
		method: 'post',
		data
	})
}
// 订单支付
export function getPayment(data) {
	return request({
		url:'/app-api/biz/home/order-payment',
		method: 'get',
		params: data
	})
}